module.exports = __webpack_public_path__ + "img/digital3.97080d49.svg";